import domtoimage from "dom-to-image";
import jsPDF from "jspdf";

export function exportElementAsPDF(element: HTMLElement) {
  domtoimage
    .toPng(element, {
      quality: 1,
      width: element.scrollWidth,
      height: element.scrollHeight,
    })
    .then((dataUrl) => {
      const pdf = new jsPDF("landscape", "pt", [
        element.scrollWidth,
        element.scrollHeight,
      ]);
      pdf.addImage(
        dataUrl,
        "PNG",
        0,
        0,
        element.scrollWidth,
        element.scrollHeight
      );
      pdf.save("apt-planing.pdf");
    });
}
